import React from "react";
import { SvgIcon } from "@material-ui/core";

const InvoicesIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path d="M18.912 15.86v-3.469l-3.468 3.469z" />
    <path d="M32.638 12h-12.85v4.3a.438.438 0 01-.438.438h-4.351v18.626a.36.36 0 00.361.36h17.278a.36.36 0 00.361-.36v-23a.36.36 0 00-.361-.364zm-7.127 20.587h-7.026c-.2 0-.36-.306-.36-.684s.161-.685.36-.685h7.026c.2 0 .36.307.36.685s-.161.684-.36.684zm4-4.085H18.485c-.2 0-.36-.309-.36-.69s.161-.69.36-.69h11.028c.2 0 .36.309.36.69s-.161.693-.36.693zm0-3.995H18.485c-.2 0-.36-.332-.36-.741s.161-.741.36-.741h11.028c.2 0 .36.332.36.741s-.161.739-.36.739zm0-4.086H21.74c-.2 0-.36-.334-.36-.746s.161-.747.36-.747h7.771c.2 0 .36.334.36.747s-.159.746-.358.746z" />
    <path d="M0 0h48v48H0z" fill="none" />
  </SvgIcon>
);
InvoicesIcon.displayName = "InvoicesIcon";
InvoicesIcon.muiName = "InvoicesIcon";

export default InvoicesIcon;
